/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { ICreateBoxArgs } from "./components";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PLATFORM_FEE_CONFIG } from "../costumePageService/graphql/getPlatformFeeConfig.query";
import { v4 as uuidv4 } from "uuid";
import {
  ITicketFete,
  ITicketOrder,
  IHoldTicketsInput,
  ITicketLineInput,
  IPayForTicketsInput,
  IPayCostumeAndTicketsInput,
  IPayTicketResult,
  IVerifyTicketPaymentResult,
} from "../../pages/Costume/components/SelectTicketsComp/types";

const is = require("is_js");

const safeSessionStorage = {
  getItem(key: string): string | null {
    if (typeof window === "undefined" || !window.sessionStorage) return null;
    try {
      return window.sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    if (typeof window === "undefined" || !window.sessionStorage) return;
    try {
      window.sessionStorage.setItem(key, value);
    } catch { }
  },
  removeItem(key: string): void {
    if (typeof window === "undefined" || !window.sessionStorage) return;
    try {
      window.sessionStorage.removeItem(key);
    } catch { }
  },
};

const SERVICE_NAME = "CostumeOpenRegPageService";
const log: any = LoggerModule.getInstance();

export class CostumeOpenRegPageService {
  private static instance: CostumeOpenRegPageService;
  private vapp: VApplication;
  private selectedCostume: any;
  private selectedTickets: any[] = [];
  private activeTicketOrder: ITicketOrder | null = null;
  private ticketFetesList: ITicketFete[] = [];
  private currentHoldRetryKey: string | null = null;
  private currentHoldFingerprint: string | null = null;
  private currentBox: any = null;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): CostumeOpenRegPageService {
    if (!CostumeOpenRegPageService.instance) {
      CostumeOpenRegPageService.instance = new CostumeOpenRegPageService(props);
    }
    return CostumeOpenRegPageService.instance;
  }

  public setSelectedCostume(data: any) {
    console.log("datadatadatadata", data);
    this.selectedCostume = data;
  }

  public getSelectedCostume() {
    console.log("datadatadatadata12", this.selectedCostume);
    return this.selectedCostume;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async updateMailAddress(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.updateBox(arg);
    return content;
  }

  public async addToCart(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.AddToCart(arg);
    return content;
  }

  public async getPresentation() {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getPresentation();

    console.log(content);
    return content;
  }
  public async getPreBookedAmt() {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getPreBookedAmt();

    return content;
  }

  public async getCostumeType(costumeId: string) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getCostumeType(costumeId);

    return content;
  }

  public async getCities() {
    const agent = getAgent();
    let content: any = {};
    let compProps: any = null;
    compProps = await agent.getMyDiscounts();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    // compProps = await agent.getCities();
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }
    compProps = await agent.getMyProfile();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }
  public async getAllCarts() {
    const agent = getAgent();
    let content: any = {};
    let compProps: any = null;
    compProps = await agent.getAllCarts();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    compProps = await agent.getMyDiscounts();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async createMultiBox(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.CreateMultiBox(arg);
    return content;
  }

  public async createMultiBoxCamp(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.CreateMultiBoxCamp(arg);
    return content;
  }

  public async deleteCart(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.deleteCart(arg);
    return content;
  }

  public async createBox(payload: ICreateBoxArgs) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.createBox(payload);

    return content;
  }
  public async createPayFAC(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.createPayFAC({ ...arg });
    return content;
  }
  public async validateDiscount(args: any) {
    console.log(args);
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.validateDiscount(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    console.log("content", content);
    return content;
  }

  public async getPlatformFeeConfig() {
    const graphqlModule = this.vapp.getSync("services.GraphqlServerModule") as GraphqlServerModule;
    const client = graphqlModule.getClient("graphql-gateway");
    if (client) {
      const res = await client.query({
        query: GET_PLATFORM_FEE_CONFIG,
        fetchPolicy: "network-only",
      });
      return res?.data?.getPlatformFeeConfig;
    }
    return null;
  }

  // --- Ticket State Management ---
  public setSelectedTickets(tickets: any[]) {
    console.log("CostumeOpenRegPageService setSelectedTickets", tickets);
    this.selectedTickets = tickets || [];
  }

  public getSelectedTickets() {
    return this.selectedTickets || [];
  }

  public setTicketFetesList(fetes: ITicketFete[]) {
    this.ticketFetesList = fetes || [];
  }

  public getTicketFetesList(): ITicketFete[] {
    return this.ticketFetesList || [];
  }

  public setActiveTicketOrder(order: ITicketOrder | null) {
    this.activeTicketOrder = order;
    if (order) {
      safeSessionStorage.setItem(
        "gems_active_ticket_order",
        JSON.stringify(order)
      );
      const orderId = order.id || (order as any).ticketOrderId;
      if (orderId) {
        safeSessionStorage.setItem("gems_ticket_order_id", orderId);
      }
    } else {
      safeSessionStorage.removeItem("gems_active_ticket_order");
      safeSessionStorage.removeItem("gems_ticket_order_id");
    }
  }

  public getActiveTicketOrder(): ITicketOrder | null {
    if (this.activeTicketOrder) {
      const currentBoxId = this.getCurrentBoxId();
      if (currentBoxId && this.activeTicketOrder.boxId && this.activeTicketOrder.boxId !== currentBoxId) {
        this.clearActiveTicketOrder();
        return null;
      }
      return this.activeTicketOrder;
    }
    const cached = safeSessionStorage.getItem("gems_active_ticket_order");
    if (cached) {
      try {
        const order = JSON.parse(cached);
        const currentBoxId = this.getCurrentBoxId();
        if (currentBoxId && order?.boxId && order.boxId !== currentBoxId) {
          this.clearActiveTicketOrder();
          return null;
        }
        this.activeTicketOrder = order;
        return this.activeTicketOrder;
      } catch {
        return null;
      }
    }
    return null;
  }

  public getActiveTicketOrderId(): string | null {
    const order = this.getActiveTicketOrder();
    if (order?.id) return order.id;
    if ((order as any)?.ticketOrderId) return (order as any).ticketOrderId;
    return (
      safeSessionStorage.getItem("gems_ticket_order_id") ||
      safeSessionStorage.getItem("gems_ticket_orderId")
    );
  }

  public clearActiveTicketOrder() {
    this.activeTicketOrder = null;
    safeSessionStorage.removeItem("gems_active_ticket_order");
    safeSessionStorage.removeItem("gems_ticket_order_id");
    safeSessionStorage.removeItem("gems_ticket_orderId");
  }

  public createHoldFingerprint(
    boxId: string,
    feteId: string,
    lines: ITicketLineInput[]
  ): string {
    const sortedLines = [...(lines || [])]
      .sort((a, b) => (a.tierId || "").localeCompare(b.tierId || ""))
      .map((l) => `${l.tierId}:${l.quantity}`)
      .join(",");
    return `${boxId}_${feteId}_${sortedLines}`;
  }

  public getOrCreateHoldRetryKey(fingerprint?: string): string {
    if (
      fingerprint &&
      this.currentHoldFingerprint === fingerprint &&
      this.currentHoldRetryKey
    ) {
      return this.currentHoldRetryKey;
    }

    if (fingerprint && !this.currentHoldRetryKey) {
      const cachedFp = safeSessionStorage.getItem(
        "gems_ticket_hold_fingerprint"
      );
      const cachedKey = safeSessionStorage.getItem(
        "gems_ticket_hold_retry_key"
      );
      if (cachedFp === fingerprint && cachedKey) {
        this.currentHoldFingerprint = cachedFp;
        this.currentHoldRetryKey = cachedKey;
        return cachedKey;
      }
    }

    const newKey = uuidv4();
    this.currentHoldRetryKey = newKey;
    this.currentHoldFingerprint = fingerprint || null;

    safeSessionStorage.setItem("gems_ticket_hold_retry_key", newKey);
    if (fingerprint) {
      safeSessionStorage.setItem("gems_ticket_hold_fingerprint", fingerprint);
    } else {
      safeSessionStorage.removeItem("gems_ticket_hold_fingerprint");
    }

    return newKey;
  }

  public getHoldRetryKey(): string | null {
    if (this.currentHoldRetryKey) return this.currentHoldRetryKey;
    return safeSessionStorage.getItem("gems_ticket_hold_retry_key");
  }

  public generateNewHoldRetryKey(fingerprint?: string): string {
    const newKey = uuidv4();
    this.currentHoldRetryKey = newKey;
    this.currentHoldFingerprint = fingerprint || null;
    safeSessionStorage.setItem("gems_ticket_hold_retry_key", newKey);
    if (fingerprint) {
      safeSessionStorage.setItem("gems_ticket_hold_fingerprint", fingerprint);
    } else {
      safeSessionStorage.removeItem("gems_ticket_hold_fingerprint");
    }
    return newKey;
  }

  public clearHoldRetryKey() {
    this.currentHoldRetryKey = null;
    this.currentHoldFingerprint = null;
    safeSessionStorage.removeItem("gems_ticket_hold_retry_key");
    safeSessionStorage.removeItem("gems_ticket_hold_fingerprint");
  }

  public getStoredTicketTxId(): string | null {
    return safeSessionStorage.getItem("gems_ticket_txId");
  }

  public getStoredTicketOrderId(): string | null {
    return safeSessionStorage.getItem("gems_ticket_orderId");
  }

  public clearStoredTicketTx() {
    safeSessionStorage.removeItem("gems_ticket_txId");
    safeSessionStorage.removeItem("gems_ticket_orderId");
  }

  // --- Box Management Helpers ---
  public setCurrentBox(box: any) {
    this.currentBox = box;
    const resolvedBoxId =
      box?.id ||
      box?._id ||
      box?.createBox?.id ||
      box?.createBoxRecord?.id;
    if (resolvedBoxId) {
      safeSessionStorage.setItem("gems_current_box_id", resolvedBoxId);
    }
    const payOrderId =
      box?.payOrder?.id ||
      (typeof box?.payOrder === "string" ? box.payOrder : null) ||
      box?.payOrderId ||
      box?.createBox?.payOrder?.id ||
      box?.createBoxRecord?.payOrder?.id;
    if (payOrderId) {
      safeSessionStorage.setItem("gems_current_pay_order_id", payOrderId);
    }
  }

  public getCurrentBox(): any {
    return this.currentBox;
  }

  public getCurrentBoxId(): string | null {
    if (this.currentBox?.id) return this.currentBox.id;
    return safeSessionStorage.getItem("gems_current_box_id");
  }

  public getCurrentPayOrderId(): string | null {
    const box = this.currentBox;
    const payOrderId =
      box?.payOrder?.id ||
      (typeof box?.payOrder === "string" ? box.payOrder : null) ||
      box?.payOrderId ||
      box?.createBox?.payOrder?.id ||
      box?.createBoxRecord?.payOrder?.id;
    if (payOrderId) return payOrderId;
    return safeSessionStorage.getItem("gems_current_pay_order_id");
  }

  public clearCurrentBox() {
    this.currentBox = null;
    safeSessionStorage.removeItem("gems_current_box_id");
    safeSessionStorage.removeItem("gems_current_pay_order_id");
    this.clearActiveTicketOrder();
  }

  // --- Ticket Queries and Mutations ---
  public async getTicketFetes(): Promise<ITicketFete[]> {
    const agent = getAgent();
    const fetes = await agent.getTicketFetes();
    this.setTicketFetesList(fetes);
    return fetes;
  }

  public async holdTickets(data: IHoldTicketsInput): Promise<ITicketOrder> {
    const boxId = data.boxId || this.getCurrentBoxId();
    if (!boxId) {
      throw new Error(
        "Cannot hold tickets without a boxId. Please ensure a box is created or selected."
      );
    }

    const fingerprint = this.createHoldFingerprint(
      boxId,
      data.feteId,
      data.lines
    );
    const idempotencyKey =
      data.idempotencyKey || this.getOrCreateHoldRetryKey(fingerprint);

    const payload: IHoldTicketsInput = {
      ...data,
      boxId,
      idempotencyKey,
    };

    const agent = getAgent();
    const result = await agent.holdTickets(payload);
    if (result) {
      this.setActiveTicketOrder(result);
      this.clearHoldRetryKey();
    }
    return result;
  }

  public async reduceTicketHold(
    ticketOrderId: string,
    lines: ITicketLineInput[]
  ): Promise<ITicketOrder> {
    const agent = getAgent();
    const result = await agent.reduceTicketHold(ticketOrderId, lines);
    if (result) {
      if (
        result.status === "RELEASED" ||
        !result.lines ||
        result.lines.length === 0 ||
        result.total === 0
      ) {
        this.clearActiveTicketOrder();
      } else {
        this.setActiveTicketOrder(result);
      }
    }
    return result;
  }

  public async releaseTicketHold(ticketOrderId: string): Promise<any> {
    const agent = getAgent();
    const result = await agent.releaseTicketHold(ticketOrderId);
    this.clearActiveTicketOrder();
    this.clearHoldRetryKey();
    return result;
  }

  public async getMyTicketOrders(boxId?: string): Promise<ITicketOrder[]> {
    const agent = getAgent();
    return await agent.getMyTicketOrders(boxId);
  }

  public async getBoxTicketOrders(boxId: string): Promise<ITicketOrder[]> {
    const agent = getAgent();
    return await agent.getBoxTicketOrders(boxId);
  }

  public async payTicketsAtMasCamp(data: {
    boxId: string;
    ticketOrderId: string;
    allocations?: { costumeValueId: string; amount: number }[];
    email?: string;
  }): Promise<any> {
    const agent = getAgent();
    return await agent.payTicketsAtMasCamp(data);
  }

  public async payForTickets(
    data: IPayForTicketsInput
  ): Promise<IPayTicketResult> {
    const agent = getAgent();
    const result = await agent.payForTickets(data);
    if (result?.txId) {
      safeSessionStorage.setItem("gems_ticket_txId", result.txId);
      safeSessionStorage.setItem("gems_ticket_orderId", data.ticketOrderId);
      if (this.activeTicketOrder) {
        this.setActiveTicketOrder({
          ...this.activeTicketOrder,
          status: "PAYING",
        });
      }
    }
    return result;
  }

  public async payCostumeAndTickets(
    data: IPayCostumeAndTicketsInput
  ): Promise<IPayTicketResult> {
    const agent = getAgent();
    const result = await agent.payCostumeAndTickets(data);
    if (result?.txId) {
      safeSessionStorage.setItem("gems_ticket_txId", result.txId);
      safeSessionStorage.setItem("gems_ticket_orderId", data.ticketOrderId);
      if (this.activeTicketOrder) {
        this.setActiveTicketOrder({
          ...this.activeTicketOrder,
          status: "PAYING",
        });
      }
    }
    return result;
  }

  public async verifyTicketPayment(
    txId: string
  ): Promise<IVerifyTicketPaymentResult> {
    const agent = getAgent();
    const result = await agent.verifyTicketPayment(txId);
    if (result?.ticketOrder) {
      this.setActiveTicketOrder(result.ticketOrder);
    }
    return result;
  }

  public async pollTicketPaymentVerification(
    txId?: string,
    options?: {
      maxRetries?: number;
      intervalMs?: number;
      onPoll?: (attempt: number, result: IVerifyTicketPaymentResult) => void;
    }
  ): Promise<IVerifyTicketPaymentResult | null> {
    const targetTxId = txId || this.getStoredTicketTxId();
    if (!targetTxId) {
      console.warn("CostumeOpenRegPageService.pollTicketPaymentVerification: No txId available to verify");
      return null;
    }

    const maxRetries = options?.maxRetries ?? 3;
    const intervalMs = options?.intervalMs ?? 2000;

    let lastResult: IVerifyTicketPaymentResult | null = null;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const result = await this.verifyTicketPayment(targetTxId);
        lastResult = result;

        if (options?.onPoll) {
          try {
            options.onPoll(attempt, result);
          } catch (callbackErr) {
            console.error("pollTicketPaymentVerification onPoll callback error:", callbackErr);
          }
        }

        const isSuccess =
          result?.status === "Success" ||
          result?.status === "CONFIRMED" ||
          result?.status === "PAID" ||
          result?.ticketOrder?.status === "PAID" ||
          result?.ticketOrder?.status === "CONFIRMED";

        const isTerminalFailure =
          result?.status === "Failed" ||
          result?.ticketOrder?.status === "FAILED" ||
          result?.ticketOrder?.status === "RELEASED" ||
          result?.ticketOrder?.status === "EXPIRED";

        if (isSuccess || isTerminalFailure || attempt === maxRetries) {
          return result;
        }

        await new Promise((resolve) => setTimeout(resolve, intervalMs));
      } catch (err) {
        console.error(`pollTicketPaymentVerification error on attempt ${attempt}:`, err);
        if (attempt === maxRetries) return lastResult;
        await new Promise((resolve) => setTimeout(resolve, intervalMs));
      }
    }

    return lastResult;
  }
}
